export default __webpack_public_path__ + "static/media/14563.investment-and-accountancy-evenings-committee.photo.84527cb2.jpg";